<template>

  <li :class="'list-group-item list-group-item-action'+(alert.delete?' bounce-leave-active':'')+(!alert.read?' no-read':'')">
    <div class="head">
      <span class="date"> {{
          $moment(alert.date_create).format("DD.MM.YY")
        }}{{ $moment(alert.date_create).format("HH:mm") }}</span>
      <a href="#" v-if="!alert.read" @click.prevent="alert.delete=true;setRead(alert)" title="Отметить прочитанным">
        <i class="bi bi-bookmark-check"></i>
      </a>
    </div>
    <h6><i :class="`bi bi-exclamation-octagon-fill text-${alert.alert_type}`"></i> {{ alert.text }}</h6>
    <a v-if="alert.link" target="_blank" @click="setRead" :href="alert.link" class="btn btn-sm btn-outline-dark">Показать</a>

  </li>

</template>

<script>

import {AlertApi} from "@/api/alerts";

export default {
  name: 'AlertItem',
  props: {
    alert: {
      type: Object, default() {
        return {}
      }
    },
  },
  methods: {
    setRead() {
      let data = JSON.parse(JSON.stringify(this.alert))
      data.read = true
      AlertApi.set_read(data).then(response => this.$store.dispatch("updateAlert", response))
    }
  }
}
</script>
<style scoped lang="scss">

.list-group-item {
  padding: 10px;

  .head {
    font-size: 9px;
    display: flex;
    justify-content: space-between;

    a {
      color: #000;
      border: 1px solid #999;
      border-radius: 5px;
      padding: 0 3px;
    }
  }
  .btn{
    color: #000;
    &:hover{
      color: #fff;
    }
  }
}

.no-read {
  background: #e7e7e7;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>
